function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M416 226v-2c0-88-72-160-160-160S96 136 96 224v2c-54 7-96 54-96 110 0 62 50 112 112 112h288c62 0 112-50 112-112 0-56-42-103-96-110"
})));